import { ProductData } from "@livechat/design-system-react-components";

import { IRequestResult } from "../api-client";
import { BaseApi } from "../base";

export default class GlobalAccountsApi extends BaseApi {
  protected readonly service = "global-accounts";
  protected readonly version = 2;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchInfo = () => this.get("info");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAccount = () => this.get("accounts/me");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  revokeToken = () => this.delete("token");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchOrganization = () => this.get("organizations/my");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSessions = () => this.get("sessions");
  fetchMyProducts = (): Promise<IRequestResult<ProductData[]>> => this.get("organizations/my/products");
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteSession = (sessionId: string) => this.delete(`sessions/${sessionId}`);
}
